import { render } from "./PublicationCard.vue?vue&type=template&id=06a760a9&scoped=true"
import script from "./PublicationCard.vue?vue&type=script&lang=js"
export * from "./PublicationCard.vue?vue&type=script&lang=js"

import "./PublicationCard.vue?vue&type=style&index=0&id=06a760a9&scoped=true&lang=scss"

import exportComponent from "/Users/ecm1922/Code/jakob-schloer.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a760a9"]])

export default __exports__